import styled, { css, keyframes } from 'styled-components'

const showProgress = accepted => keyframes`
  0% {
    transform: translate(${accepted ? '0,0' : '-100%, 0 '});
  }
  100% {
    transform: translate(${accepted ? '0, 100%' : '0, 0'});
  }
`
const confirmAccepted = keyframes`

    0% {
        transform: translate(0,100%);
    }
    100% {
      transform: translate(0, 200%);
    }
`

export const AcceptButton = styled.button`
  ${({
    accepting,
    accepted,
    initial,
    revealButton,
    done,
    theme: { colors },
  }) => css`
    background-color: ${revealButton || done ? '#0A5B8B' : colors.abyss};
    color: #fff;
    padding: 15px 20px;
    outline: 0;
    position: relative;
    overflow: hidden;
    border: 0;
    cursor: pointer;
    border-radius: 5px;
    span {
      display: flex;
      transform: ${accepting ? 'scale(0.95, 0.95)' : 'scale(1, 1)'};
      transition: transform 0.3s linear;
      i {
        margin: 0 0 0 5px !important;
      }
    }
    ::before {
      display: ${initial || done ? 'none' : 'block'};
      content: '';
      position: absolute;
      z-index: 100;
      top: calc(-100% + 4px);
      animation-play-state: ${accepting || accepted ? 'running' : 'paused'};
      transform: translateX(-100%);
      left: 0;
      animation: ${accepting ? '3s' : '150ms'}
        ${revealButton ? confirmAccepted : showProgress(accepted)} linear
        forwards;

      background-color: ${colors.red};
      width: 100%;
      height: 100%;
    }
    ::after {
      display: ${accepting ? 'block' : 'none'};
      content: '';
      background: #fff;
      opacity: 0.2;
      position: absolute;
      top: calc(-100% + 4px);
      left: 0;
      width: 100%;
      height: 100%;
    }
  `}
`
